import { request } from '@/utils/api/request';

import { CHANNEL_ID, EBAY } from '@/constants/channels';
import { ENDPOINT } from '@/constants/api';
import { STATUSES } from '@/constants/shops';

export const shops = {
  createVelaShop({ channel, db, shopId, optimize }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V3,
      payload: {
        target_channel: CHANNEL_ID[channel],
        optimize,
      },
      params: {
        db,
      },
      url: `/shops/${shopId}/vela-only`,
    });
  },
  getActiveListingsCount() {
    return request.get({
      endpoint: ENDPOINT.WEB_V3,
      url: '/shops/vela-only/listings-count-from-source-shops',
    });
  },
  refresh({ channel, db, shopId }) {
    switch (channel) {
      case EBAY: {
        return request.get({
          endpoint: ENDPOINT.WEB_V2,
          url: `/${channel}/shops/${shopId}/refresh`,
        });
      }

      default: {
        return request.get({
          params: {
            db,
            userAction: STATUSES.USER_INITIATED_REFRESH,
          },
          url: `/shops/${shopId}/refresh`,
        });
      }
    }
  },
  setTitlePreference({ shopId, preference, db }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V2,
      payload: { titleFormatPreference: preference },
      params: { db },
      url: `/etsy/shops/${shopId}/title_format_preference`,
    });
  },
  resetPublicError({ shopId, db }) {
    return request.delete({
      endpoint: ENDPOINT.WEB,
      url: `/shops/${shopId}/publicError?db=${db}`,
    });
  },
};
